(() => {
  if (customElements.get('loci-size-alternatives')) return;

  const euSize = title => String(title || '').match(/\bEU\s+(\d+(?:\.\d+)?)\b/i)?.[1] || null;

  class LociSizeAlternatives extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      this.abort = new AbortController();
      const form = document.getElementById(this.getAttribute('form-id'));
      if (!form) return;
      try {
        this.data = JSON.parse(this.querySelector('[data-size-alternatives-data]').textContent);
      } catch { return; }
      const options = { signal: this.abort.signal };
      form.addEventListener('variant:change', event => {
        try { this.render(event.detail?.variant); } catch { this.hidden = true; }
      }, options);
      form.addEventListener('product:rerender', event => {
        this.hidden = true;
        const fresh = event.detail?.htmlFragment?.querySelector('loci-size-alternatives[form-id="' + CSS.escape(form.getAttribute('id')) + '"] [data-size-alternatives-data]');
        if (fresh) {
          try { this.data = JSON.parse(fresh.textContent); } catch { this.data = null; }
        }
      }, options);
      document.addEventListener('change', event => {
        if (event.target instanceof HTMLInputElement && event.target.form === form && event.target.hasAttribute('data-option-position')) this.hidden = true;
      }, { ...options, capture: true });
    }

    disconnectedCallback() { this.abort?.abort(); }

    render(variant) {
      this.hidden = true;
      if (!this.data || !variant || variant.available !== false) return;
      const current = this.data.variants.find(item => String(item.id) === String(variant.id));
      const size = euSize(current?.title);
      if (!size) return;
      const alternatives = this.data.products.map(product => ({
        product,
        variant: product.variants.find(item => euSize(item.title) === size)
      })).filter(item => item.variant).slice(0, 3);
      if (!alternatives.length) return;
      this.querySelector('.loci-size-alternatives__heading').textContent = this.data.heading;
      this.querySelector('.loci-size-alternatives__description').textContent = this.data.description.replace('__SIZE__', size);
      const cards = this.querySelector('.loci-size-alternatives__cards');
      cards.replaceChildren();
      alternatives.forEach(({ product, variant: alternative }) => {
        const card = document.createElement('article');
        card.className = 'loci-size-alternatives__card';
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = product.title + ' — ' + product.colour;
        image.width = 360;
        image.height = 277;
        image.loading = 'lazy';
        const colour = document.createElement('p');
        colour.className = 'loci-size-alternatives__colour';
        colour.textContent = product.colour;
        const price = document.createElement('p');
        price.className = 'loci-size-alternatives__price';
        price.textContent = alternative.price.replace(/<[^>]*>/g, '');
        const link = document.createElement('a');
        link.className = 'loci-size-alternatives__link';
        const url = new URL(product.url, location.origin);
        url.searchParams.set('variant', alternative.id);
        const params = new URLSearchParams(location.search);
        ['sizesfor', 'preview_theme_id'].forEach(key => {
          if (params.has(key)) url.searchParams.set(key, params.get(key));
        });
        link.href = url.pathname + url.search;
        link.textContent = this.data.link.replace('__SIZE__', size) + ' →';
        link.setAttribute('aria-label', product.colour + ' — ' + this.data.link.replace('__SIZE__', size));
        card.append(image, colour, price, link);
        cards.append(card);
      });
      this.hidden = false;
    }
  }
  customElements.define('loci-size-alternatives', LociSizeAlternatives);
})();
